import axios from 'axios';
import SurveyProject from './survey-project.entity';
import Survey from './survey.entity';
import { DeliveryObject } from '@/domain/survey/delivery-object-interface';

export default class SurveyService {
  static createSurvey(workItem: any, survey: SurveyProject) {
    return axios.post(`/workitems/${workItem}/survey`, survey)
      .then((response: any) => response);
  }

  static createEmailSurvey(survey: Survey) {
    return axios.post('/workitems/survey/email', survey)
      .then((response: any) => response);
  }

  static createLinkSurvey(delivery: DeliveryObject) {
    return axios.post('/survey-api/survey/link-survey', delivery)
      .then((response: any) => response);
  }
}
